/*
 * @Author: Dom
 * @Date: 2022-07-18 16:54:01
 * @LastEditTime: 2022-07-18 17:04:36
 * @LastEditors: Dom
 * @FilePath: \operator-web\src\services\site.ts
 */
import request from '@/utils/request'
import {SiteParamsType} from '@/services/data.d'

export async function getSiteList(params:{}): Promise<any>{
    return request({
        url: '/seller/v1/station/getList',
        method: 'POST',
        data: params
    })
}
